export const STICKY_SIDE_BAR_WIDTH = '286px'; // should be 270px + 16px padding accounting for shadows
